import { render, staticRenderFns } from "./LiteDownloads.vue?vue&type=template&id=75ede4b6&scoped=true"
import script from "./LiteDownloads.vue?vue&type=script&setup=true&lang=js"
export * from "./LiteDownloads.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LiteDownloads.vue?vue&type=style&index=0&id=75ede4b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ede4b6",
  null
  
)

export default component.exports